module.exports = __webpack_public_path__ + "static/media/coming-soon.c4ade146.png";